<template>
    <div>
        <rkm-row class="mb-2">
            <rkm-col>
                <rkm-form-radio-group
                    :options="form.causasExternas"
                    :validations="validations.causaExterna"
                    text-field="nome"
                    v-model="model.causaExternaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :mask="mask.cnpj"
                    :validations="validations.cnpjSeguradora"
                    label="CNPJ da seguradora"
                    uppercase
                    v-model="model.cnpjSeguradora"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.numeroBilhete"
                    label="Nº do bilhete"
                    v-model="model.numeroBilhete"
                />
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    :validations="validations.serie"
                    label="Série"
                    v-model="model.serie"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :mask="mask.cnpj"
                    :validations="validations.cnpjEmpresa"
                    label="CNPJ da empresa"
                    uppercase
                    v-model="model.cnpjEmpresa"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.cnaeEmpresa"
                    label="CNAE da empresa"
                    v-model="model.cnaeEmpresa"
                />
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    :validations="validations.cbor"
                    label="CBOR"
                    v-model="model.cbor"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :options="form.vinculosPrevidencia"
                    :validations="validations.vinculoPrevidencia"
                    label="Vínculo com a previdência"
                    text-field="nome"
                    v-model="model.vinculoPrevidenciaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import { mask } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                causaExterna: {},
                cnpjSeguradora: { cnpj: true },
                numeroBilhete: { max: 10 },
                serie: { max: 6 },
                cnpjEmpresa: { cnpj: true },
                cnaeEmpresa: { max: 10 },
                cbor: { max: 3 },
                vinculoPrevidencia: {},
            }
        },
    },
    mixins: [mask],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>